import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Markdown } from "@/components/Markdown";
import { Loader2, ChevronLeft } from "lucide-react";

export default function LegalPolicy() {
    const { slug } = useParams();
    const [p, setP] = useState(undefined);
    const nav = useNavigate();

    useEffect(() => {
        setP(undefined);
        api.get(`/legal/policies/${slug}`).then((r) => setP(r.data)).catch(() => setP(null));
    }, [slug]);

    return (
        <div className="mx-auto min-h-screen max-w-md bg-white">
            <div className="sticky top-0 z-10 flex items-center gap-3 border-b border-navy/10 bg-navy px-5 py-4 text-white">
                <button data-testid="policy-back-btn" onClick={() => nav("/legal")} className="rounded-full bg-white/10 p-1.5 hover:bg-white/20"><ChevronLeft size={18} /></button>
                <span className="truncate font-heading text-base font-bold">{p ? p.title : "Policy"}</span>
            </div>

            <div className="px-5 py-5">
                {p === undefined && <div className="flex justify-center py-12"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>}
                {p === null && <p className="py-12 text-center text-sm text-navy/50">Policy not found.</p>}
                {p && (
                    <div data-testid="policy-content">
                        <div className="mb-3 flex items-center gap-2 text-xs text-navy/45">
                            <span className="rounded-full bg-navy/5 px-2 py-0.5 font-semibold">v{p.version}</span>
                            {p.effective_date && <span>Effective {p.effective_date}</span>}
                        </div>
                        <Markdown content={p.content} />
                    </div>
                )}
            </div>
        </div>
    );
}
